import AuthRequest from './auth_request';
const origin = 'https://api.goxapp.com';

function url(path, version = 'v1') {
  return `${origin}/${version}/${path}`;
}

function submitNumber(phone, phone_country) {
  return AuthRequest.post(url('auth'), {phone, phone_country});
}

function submitCode(phone, phone_country, token, code) {
  return AuthRequest.post(url('auth_code'), {auth: {phone, phone_country, token, code}});
}

function ridesActive() {
  return AuthRequest.get(url('rides/active'));
}

function turboMode(rideId, command) {
  return AuthRequest.post(url(`rides/${rideId}/turbo?command=${command}`));
}

function rideComplete(rideId) {
  return AuthRequest.delete(url(`rides/${rideId}`));
}

function users() {
  return AuthRequest.get(url('users'));
}

function rideStart(uuid, pricing_plan_id) {
  return AuthRequest.post(url('rides'), { uuid, pricing_plan_id });
}

function scooterShow(uuid) {
  return AuthRequest.get(url(`scooters/${uuid}`));
}

function braintreeClientToken() {
  return AuthRequest.get(url('users/client_token'));
}

function hasCard() {
  return AuthRequest.get(url('braintree/default_card'));
}

function addCard(payment_method_nonce, device_data) {
  return AuthRequest.post(url('braintree/add_card'), { payment_method_nonce, device_data })
}

function addFunds(refill_plan_id) {
  return AuthRequest.post(url('users/add_funds'), { refill_plan_id });
}

function scootersAvailable(lat, lng, radius = 2000) {
  return AuthRequest.get(url(`scooters/available?lat=${lat}&lng=${lng}&radius=${radius}`));
}

function parkingZones(scooterId) {
  return AuthRequest.get(url(`parking_zones?scooter_id=${scooterId}`));
}

export default {
  submitNumber,
  submitCode,
  ridesActive,
  turboMode,
  rideComplete,
  users,
  rideStart,
  scooterShow,
  braintreeClientToken,
  hasCard,
  addCard,
  addFunds,
  scootersAvailable,
  parkingZones
}
